import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name fieldKeyService
     * @memberof app
     *
     * @description
     * Will provide you with the correct keys for either the platform setting values or the originals.
     *
     * @author flzemke.btc
     */
    angular.module('app').service('fieldKeyService', fieldKeyService);

    function fieldKeyService() {
        return {
            initialize: initialize
        };

        function initialize(pkpUseOriginalsAttr) {
            var valueKey = '';
            var unitKey = '';

            if (!angular.isUndefined(pkpUseOriginalsAttr)) {
                valueKey = 'originalValue';
                unitKey = 'originalUnit';
            } else {
                valueKey = 'value';
                unitKey = 'unit';
            }

            return {
                valueKey: valueKey,
                unitKey: unitKey
            };
        }
    }
})();
